{
  "ACTIONS": {
    "CONFIRM": "ยืนยัน",
    "CONTINUE": "ดำเนินการต่อ",
    "SUBMIT": "ส่ง",
    "RETRY": "ลองอีกครั้ง",
    "CANCEL": "ยกเลิก",
    "EMPTY": "คุณไม่มีรายการสั่งซื้อ",
    "LOADING_ORDERS": "กำลังเตรียมบิลของคุณ",
    "CLEAR_ALL": "Clear All",
    "AWESOME": "Awesome!",
    "VIEW_RECEIPT": "The Receipt",
    "ADD_CART": "Add to Cart",
    "UPDATE_CART": "Update Cart",
    "EDIT": "Edit",
    "SEARCH_PLACEHOLDER": "Search for food or restaurants"
  },
  "COMMON": {
    "CALORIES": "Cal. {{calories}}",
    "MISSING_SELECTIONS": "Some options are missing, please select before proceeding",
    "ITEM_UNAVAILABLE": "This item is currently not available",
    "SECTION_NOT_FOUND": "ไม่มีหมวดนี้แล้ว",
    "ITEM_NOT_FOUND": "ไม่มีรายการนี้แล้ว",
    "PROMOTION_NOT_AVAILABLE": "โปรโมชันนี้สิ้นสุดแล้ว",
    "REQUIRED": "Required",
    "COMBO": "คอมโบ",
    "INVALID_EMAIL": "กรุณากรอกที่อยู่อีเมลที่ถูกต้อง",
    "INVALID_PHONE": "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง",
    "FEES": "Fees",
    "MIN_ORDER_ERROR": "Minimum order value of {{currency}} {{amount}} is required to place your order",
    "ADD_MIN_ORDER": "Add {{currency}} {{amount}} to place your order",
    "CONNECTION_ERROR": "เกิดข้อผิดพลาดในการโหลดโต๊ะนี้ กรุณาลองอีกครั้ง",
    "TABLE_NOT_FOUND": "ไม่พบโต๊ะนี้ กรุณาสแกน QR ใหม่อีกครั้ง"
  },
  "LANGUAGES": {
    "EN": "English",
    "AR": "عربي",
    "FA": "فارسي",
    "HI": "हिन्दी",
    "RU": "русский",
    "DE": "Deutsch",
    "FR": "Français",
    "TH": "ไทย",
    "EL": "Ελληνικά",
    "CNR": "Crnogorski",
    "ZH-HANS": "中文",
    "RO": "Română",
    "HU": "Magyar",
    "BG": "български",
    "TR": "Türkçe",
    "ES": "Español"
  },
  "BILL": {
    "NAME": "Last Name",
    "ROOM_NUMBER": "Room Number",
    "SNACKBAR_TITLE": "บิลของคุณอยู่ในระหว่างการจัดส่ง",
    "PAY_BILL": "ชำระบิล"
  },
  "PAY_AT_TABLE": {
    "TOTAL_PEOPLE": "จำนวนคนทั้งหมดที่โต๊ะ",
    "PAYING_FOR": "จำนวนคนที่คุณชำระเงินให้",
    "REMAINING": "จำนวนเงินที่เหลือ",
    "CHEQUE": "บิล",
    "AMOUNT_PAID": "จำนวนเงินที่ชำระแล้ว",
    "DISCOUNT": "ส่วนลด",
    "PROMO": "โปรโมชัน",
    "FEES": "ค่าธรรมเนียม",
    "PAID_ITEMS": "รายการที่ชำระแล้ว",
    "SPLIT_BILL": "แยกบิล",
    "EDIT_SPLIT": "แก้ไขการแยกบิล",
    "PAY_BILL": "ชำระบิล",
    "SPLIT_TITLE": "แยกบิล",
    "SPLIT_SUBTITLE": "เลือกวิธีที่คุณต้องการแยกบิล",
    "SPLIT_EVENLY": "หารเท่ากัน",
    "CUSTOM_AMOUNT": "กำหนดจำนวนเงินเอง",
    "ADD_CUSTOM_AMOUNT": "เพิ่มจำนวนเงินที่กำหนดเอง",
    "CUSTOM_AMOUNT_PLACEHOLDER": "ใส่จำนวนเงินที่กำหนดเอง",
    "PAY_FOR_ITEMS": "ชำระเฉพาะรายการของคุณ",
    "CONFIRM_SELECTION": "ยืนยันการเลือก",
    "SOMEONE_ELSE_PAYING": "มีคนที่โต๊ะของคุณกำลังชำระเงินอยู่"
  },
  "COMBO": {
    "ADD_N": "เพิ่ม {{count}} {{section}}",
    "REMOVE_N": "ลบ {{count}} {{section}}",
    "CANNOT_PROCEED": "กรุณาทำตามคำแนะนำด้านบนเพื่อเลือกคอมโบให้ครบก่อนดำเนินการต่อ",
    "COMPLETE": "คอมโบ {{combo}} ครบแล้ว!",
    "ON_ANOTHER_SECTION": "นี่เป็นส่วนหนึ่งของคอมโบ {{section}} ของคุณ"
  },
  "CART": {
    "TITLE": "รถเข็น",
    "RECOMMENDATION": "คุณอาจชอบสิ่งนี้",
    "TOTAL": "ยอดรวม",
    "VIEW": "ดูรายการสั่งซื้อในรถเข็น & สั่งซื้อ",
    "EMPTY": "รถเข็นเปล่า",
    "PLACE_ORDER": "สั่งซื้อ",
    "ADD_TO_BILL": "เพิ่มลงในบิล",
    "PAY_NOW": "ชำระเงินตอนนี้",
    "OOPS": "ขออภัยค่ะ/ครับ",
    "ADD_NEW_VARIANT": "เพิ่มอีกรายการ",
    "VARIANT_TITLE": "เปลี่ยนใจหรือเปล่า",
    "ITEM_UPDATED": "An item in your cart has been updated",
    "ITEM_REMOVED": "An item was removed from your cart because it's no longer available",
    "ITEM_LINE": "{{name}}",
    "CONFIRM_CLEAR": "Are you sure you want to clear the cart?",
    "CLEAR": "Clear Cart",
    "ADD_NOTE": "ADD A NOTE",
    "NOTE_LABEL": "Note"
  },
  "PAYMENT": {
    "CONFIRMED": "Your order has been paid !",
    "ERROR": "An error occurred during payment, please try again",
    "APPLE_PAY_TAP_AGAIN": "Please tap Apple Pay again to continue",
    "TITLE": "การชำระเงิน",
    "PAY_CARD": "Checkout",
    "SUCCESSFUL": "Payment Was Successful",
    "SUMMARY": "Payment Summary",
    "PROGRESS": "Payment in progress..., please wait",
    "CANCEL": "Please do not refresh this page or click on the back button. If you wish to cancel, please press the cancel button on the payment machine."
  },
  "ORDER": {
    "TITLE": "รายการสั่งซื้อของฉัน",
    "CONFIRMED": "Confirmed",
    "NOTES": "Order Notes",
    "TOTAL": "ยอดรวม",
    "SUBTOTAL": "Subtotal",
    "ORDER": "รายการสั่งซื้อ",
    "PAID": "Paid",
    "PLACED": "Your Order Has Been Placed",
    "UNPAID": "คำสั่งซื้อของคุณยังไม่ได้ชำระเงิน",
    "CANCELLED": "คำสั่งซื้อของคุณถูกยกเลิกแล้ว",
    "VOID": "คำสั่งซื้อของคุณถูกยกเลิกรายการแล้ว",
    "UPDATED": "คำสั่งซื้อของคุณได้รับการอัปเดตแล้ว",
    "ORDERS": "Orders",
    "PREVIOUS": "Previous Orders",
    "REJECTED": "Oops! One or more items or modifiers are currently unavailable and have been removed from your cart."
  },
  "WAITER": {
    "SNACKBAR_TITLE": "เราจะติดต่อกลับหาคุณโดยเร็วที่สุด",
    "HELP": "ให้เราช่วยเหลืออะไรคุณได้บ้าง",
    "ADDITIONAL_COMMENTS": "Comments"
  },
  "MENU": {
    "SKIP": "ข้าม",
    "MENU": "เมนู",
    "SEARCH": "ค้นหา",
    "NO_SEARCH_RESULTS": "ไม่พบรายการที่ตรงกับการค้นหาของคุณ",
    "SEARCH_OTHER_SECTIONS": "เราพบรายการที่ตรงกันในหมวดอื่น",
    "NO_FILTER_RESULTS": "ไม่มีรายการที่ตรงกับตัวกรองของคุณ",
    "CLEAR_FILTERS": "ล้างตัวกรอง",
    "NO_SECTIONS": "ไม่มีหมวดที่พร้อมใช้งาน",
    "STAFF": "พนักงานบริการ",
    "FILTERS": "Dietery Filters"
  },
  "SETTINGS": {
    "TITLE": "การตั้งค่า",
    "LANGUAGE": "ภาษา",
    "SELECT_LANGUAGE": "เลือกภาษา",
    "CURRENCY": "Currency"
  },
  "HOTEL_PREFERENCE": {
    "ROOM": "คิดรวมกับค่าห้อง"
  },
  "RESCAN": {
    "TITLE": "QR",
    "ACTION": "Please rescan the QR to continue your session",
    "SESSION_EXPIRED": "Your session has expired"
  },
  "PICKUP": {
    "TITLE": "Your Details"
  },
  "VOUCHER": {
    "ADD": "Add a Voucher",
    "PLACEHOLDER": "ใส่คูปองของคุณ",
    "VOUCHER": "Voucher",
    "DISCOUNTED_AMOUNT": "Total After Discount",
    "CURRENT_BALANCE": "Balance",
    "REMAINING_BALANCE": "Balance After Purchase",
    "AMOUNT_DUE": "Amount Due"
  },
  "TIP": {
    "TIP": "ทิป",
    "ADD": "เพิ่มทิป",
    "PLACEHOLDER": "ใส่จำนวนเงินทิป"
  },
  "LANDING": {
    "CALL_WAITER": "เรียกพนักงาน",
    "VIEW_BILL": "ดูบิล - ",
    "LOADING_BILL": "กำลังโหลดบิล"
  },
  "LOADER": {
    "Heading": "กำลังดำเนินการชำระเงินของคุณ...",
    "Subheading": "กรุณาอย่าปิดหน้านี้ เรากำลังยืนยันการชำระเงินและจะพาคุณไปยังหน้าถัดไปโดยอัตโนมัติ",
    "Hint": "โดยปกติใช้เวลาไม่กี่วินาที"
  },
  "NoVoucher": "ไม่พบคูปองนี้",
  "VoucherDisabled": "คูปองนี้ถูกปิดใช้งาน",
  "VoucherExpired": "คูปองนี้หมดอายุแล้ว",
  "VoucherAlreadyUsed": "คูปองนี้ถูกใช้ไปแล้ว",
  "VoucherZeroBalance": "คูปองนี้มียอดคงเหลือ 0",
  "VoucherUserLimitReached": "คุณใช้คูปองนี้ไปแล้ว",
  "VoucherFirstOrderOnly": "คูปองนี้ใช้ได้เฉพาะคำสั่งซื้อแรกของคุณเท่านั้น",
  "VoucherNotApplicable": "คูปองนี้ไม่สามารถใช้กับสินค้าในคำสั่งซื้อของคุณได้"
}
